import React from 'react'
import Certificate from '../../types'
import { getCertMoney } from '../../lib'
import s from './index.module.scss'
import classNames from 'classnames'

const Button: React.FC<{ certificate: Certificate }> = ({ certificate }) => {
    const isFlexibleNominal = Number(certificate.nominal_flexible) === 1
    const hasAmount = Number(certificate.amount) !== 0
    const shouldHideLabel = certificate.type === 'INFO' || (isFlexibleNominal && !hasAmount)

    return (
        <div className={s.certificate} style={{ backgroundImage: `url('${certificate.logo}')` }}>
            {certificate.request_status > 1 && (
                <div className={s.labelCertWasted}>{certificate.status_description}</div>
            )}

            <div className={classNames(s.label, { [s.hidden]: shouldHideLabel })}>
                {/*<p>{certificate.quantity} {certificate.quantity_symbol} </p>*/}
                {/* quantity shown only when nominal_flexible == 0 */}
                {(certificate?.nominal_flexible === '0' || certificate?.nominal_flexible === 0) && (
                    <p>
                        {certificate.quantity} {certificate.quantity_symbol}
                    </p>
                )}

                {hasAmount && (
                    <p>
                        {getCertMoney(certificate)} {certificate.currency_symbol}
                    </p>
                )}

                {/*<div className="gi-card-status" style={{ color: certificate.request_status > 1 ? 'red' : 'green' }}>*/}
                {/*    /!*{certificate.status_description}*!/*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export default Button
